import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { CheckboxGroup, CheckboxWithText } from 'components'
import * as Types from 'types'
import {
  formatObjectsToIds,
  parseIdsToObjects,
  yankBy,
  serializeOptions,
  isOtherType,
} from 'utils'

// Render the language checkboxes across multiple columns once the list grows
// past this many options. Each column holds at most this many options, so a new
// column is added for every additional block of 10 languages.
const MAX_OPTIONS_PER_COLUMN = 10

const propTypes = {
  languages: PropTypes.arrayOf(Types.resourceType).isRequired,
  prefix: PropTypes.string,
}

function LanguageForm({ languages, prefix = '' }) {
  const [otherLanguage, definedLanguages] = useMemo(
    () => yankBy(languages, isOtherType),
    [languages]
  )
  // Sort alphabetically by display name. "Other" is yanked out above and
  // rendered separately below, so it always stays at the end of the list.
  const sortedLanguages = useMemo(
    () =>
      [...definedLanguages].sort((a, b) =>
        (a.displayName || '').localeCompare(b.displayName || '', undefined, {
          sensitivity: 'base',
        })
      ),
    [definedLanguages]
  )
  const base = prefix ? `${prefix}.` : ''
  const checkboxGroupClassName =
    sortedLanguages.length > MAX_OPTIONS_PER_COLUMN
      ? 'language-checkbox-group language-columns'
      : 'language-checkbox-group'
  return (
    <div>
      <Field
        name={`${base}requestedLanguages`}
        label={false}
        className={checkboxGroupClassName}
        component={CheckboxGroup}
        format={formatObjectsToIds('languageId')}
        parse={parseIdsToObjects('languageId')}
        options={serializeOptions(sortedLanguages)}
      />
      {otherLanguage && (
        <Field
          name={`${base}otherText`}
          label={otherLanguage.displayName}
          placeholder="Description..."
          component={CheckboxWithText}
        />
      )}
    </div>
  )
}

LanguageForm.propTypes = propTypes
export default LanguageForm
